import request from '@/utils/request';

export const getLogData = (query) => request({
    url: '/api/experiment/log/lastest',
    method: 'get',
    params: { cursor: query }
});

// 获取菜单
export function getRoutes(query) {
    return request({
        url: '/api/experiment/menu/routes',
        method: 'get',
        params: query
    });
}

// 获取错误 测试
export function testFail(data) {
    return request({
        url: '/api/experiment/info/testFail',
        method: 'post',
        data
    });
}

// refresh
export function refresh(tenantId, refresh_token) {
    return request({
        url: '/api/blade-auth/oauth/token',
        method: 'post',
        headers: {
            'Tenant-Id': tenantId
        },
        params: {
            tenantId,
            refresh_token,
            grant_type: 'refresh_token',
            scope: 'all'
        }
    });
}

// 获取试验状态
export function getUserExperimentState(query) {
    return request({
        url: '/api/experiment/info/getUserExperimentState',
        method: 'get',
        params: query
    });
}



// WEBPACK FOOTER //
// ./src/api/login.js